// src/components/nav-section/NavSection.js

import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText, Divider, Tooltip, useTheme } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
  isCollapsed: PropTypes.bool,
};

export default function NavSection({ data = [], isCollapsed = false, ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item, index) => (
          item.type === 'separator' ? (
            <Divider key={item.type + index} sx={{ my: 1, mx: isCollapsed ? 1 : 0 }} />
          ) : (
            <NavItem key={item.title} item={item} isCollapsed={isCollapsed} />
          )
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  isCollapsed: PropTypes.bool,
  item: PropTypes.object,
};

export function NavItem({ item, isCollapsed = false }) {
  const { title, path, icon, info } = item;
  const theme = useTheme();

  const navItem = (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        color: theme.palette.grey[500],
        px: isCollapsed ? 0.75 : 2,
        justifyContent: isCollapsed ? 'center' : 'flex-start',
        '&.active': {
          color: theme.palette.common.white,
          background: 'radial-gradient(circle at 0%50%, #828282 0%, transparent 5%), radial-gradient(ellipse at 80%, #828282 0%, transparent 10%)',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>{icon}</StyledNavItemIcon>

      {!isCollapsed && <ListItemText disableTypography primary={title} />}

      {!isCollapsed && info}
    </StyledNavItem>
  );

  if (!isCollapsed) {
    return navItem;
  }

  return (
    <Tooltip title={title} placement="right">
      {navItem}
    </Tooltip>
  );
}
